/**
 * TipoDeRisco Chip Component
 * Displays a colored chip based on the risk type
 *
 * @version 2025.1.0
 */
import React from 'react';
import { Chip } from '@mui/material';
import {
  VolumeUp as PhysicalIcon,
  Science as ChemicalIcon,
  Biotech as BiologicalIcon,
  Accessibility as ErgonomicIcon,
  Warning as AccidentIcon,
} from '@mui/icons-material';
import { TipoDeRisco, getTipoDeRiscoLabel, getTipoDeRiscoColor } from '../../../types/epi';

interface TipoDeRiscoChipProps {
  tipo: TipoDeRisco;
  size?: 'small' | 'medium';
}

const getIcon = (tipo: TipoDeRisco) => {
  switch (tipo) {
    case TipoDeRisco.FISICO:
      return <PhysicalIcon />;
    case TipoDeRisco.QUIMICO:
      return <ChemicalIcon />;
    case TipoDeRisco.BIOLOGICO:
      return <BiologicalIcon />;
    case TipoDeRisco.ERGONOMICO:
      return <ErgonomicIcon />;
    case TipoDeRisco.ACIDENTE:
      return <AccidentIcon />;
    default:
      return null;
  }
};

export const TipoDeRiscoChip: React.FC<TipoDeRiscoChipProps> = ({
  tipo,
  size = 'small',
}) => {
  return (
    <Chip
      icon={getIcon(tipo) || undefined}
      label={getTipoDeRiscoLabel(tipo)}
      size={size}
      color={getTipoDeRiscoColor(tipo)}
      variant="outlined"
    />
  );
};

export default TipoDeRiscoChip;
